import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Authentication = {
  __typename?: 'Authentication';
  token: Scalars['String'];
  user: User;
};

export type AuthenticationCodeInput = {
  code: Scalars['String'];
};

export type AuthenticationPinInput = {
  email: Scalars['String'];
  pin: Scalars['String'];
};

export type AuthenticationTokenInput = {
  token: Scalars['String'];
};

export type Camp = {
  __typename?: 'Camp';
  ageMax?: Maybe<Scalars['Int']>;
  ageMin?: Maybe<Scalars['Int']>;
  campDirector?: Maybe<Trainer>;
  caption?: Maybe<Scalars['String']>;
  certificateType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dispositions?: Maybe<Array<Disposition>>;
  end?: Maybe<Scalars['String']>;
  finished?: Maybe<Scalars['Boolean']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  openDispositions?: Maybe<Scalars['Boolean']>;
  participantsCount?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  talentCardType?: Maybe<Scalars['String']>;
  trainers?: Maybe<Array<Trainer>>;
  type?: Maybe<Scalars['String']>;
};

export type CampInput = {
  ageMax?: InputMaybe<Scalars['Int']>;
  ageMin?: InputMaybe<Scalars['Int']>;
  caption?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['String']>;
  finished?: InputMaybe<Scalars['Boolean']>;
  image?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  openDispositions?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Certificate = {
  __typename?: 'Certificate';
  birthday: Scalars['String'];
  camp: Camp;
  caption: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageWithBackground?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  participantId: Scalars['String'];
  talentClass: Scalars['Int'];
  talentId?: Maybe<Scalars['String']>;
  vote: Array<Scalars['Float']>;
};

export type CertificateAddInput = {
  accountId: Scalars['String'];
  birthday: Scalars['String'];
  campId: Scalars['String'];
  club: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  participantId: Scalars['String'];
};

export type CertificateCreateInput = {
  birthday: Scalars['String'];
  campId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  participantId: Scalars['String'];
};

export type CertificateCreateWithJmtAccountInput = {
  birthday: Scalars['String'];
  campId: Scalars['String'];
  club: Scalars['String'];
  firstName: Scalars['String'];
  jmtPassword: Scalars['String'];
  jmtUsername: Scalars['String'];
  lastName: Scalars['String'];
  participantId: Scalars['String'];
};

export enum ChartType {
  AdStage = 'adStage',
  Pie = 'pie',
  Radar = 'radar'
}

export type Disposition = {
  __typename?: 'Disposition';
  id: Scalars['ID'];
  note_to_organizers?: Maybe<Scalars['String']>;
  status: DispositionStatus;
  trainer: Trainer;
};

export type DispositionInput = {
  campId: Scalars['String'];
  note_to_organizers?: InputMaybe<Scalars['String']>;
  status: DispositionStatus;
};

export enum DispositionStatus {
  Available = 'available',
  Cancelled = 'cancelled',
  Scheduled = 'scheduled',
  Standby = 'standby',
  Unavailable = 'unavailable'
}

export type EditTrainerInput = {
  campId: Scalars['String'];
  trainerId: Scalars['String'];
};

export enum Gender {
  Diverse = 'diverse',
  Female = 'female',
  Male = 'male'
}

export type Group = {
  __typename?: 'Group';
  id: Scalars['ID'];
  missingVotes?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  participants: Array<Participant>;
  trainer?: Maybe<Trainer>;
};

export type GroupInput = {
  campId: Scalars['String'];
  name: Scalars['String'];
};

export type ImageInput = {
  image?: InputMaybe<Scalars['String']>;
  participantId: Scalars['String'];
};

export type JmtUser = {
  __typename?: 'JmtUser';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type JmtUserInput = {
  name: Scalars['String'];
  password: Scalars['String'];
};

export type MarkedSpecialTalent = {
  __typename?: 'MarkedSpecialTalent';
  eventId: Scalars['String'];
  from: Trainer;
  isTalent: Scalars['Boolean'];
  participant: Participant;
};

export type Mutation = {
  __typename?: 'Mutation';
  addMultipleToGroup: Group;
  addParticipant: Participant;
  addToAccountAndPushCertificate?: Maybe<Scalars['Boolean']>;
  addToGroup: Group;
  checkJMTAccount?: Maybe<JmtUser>;
  clearAllRoleOverrides: Scalars['String'];
  createAccountAndPushCertificate?: Maybe<Scalars['Boolean']>;
  createCamp: Camp;
  createDisposition: Camp;
  createGroup: Group;
  createJMTAccountAndPushCertificate?: Maybe<Scalars['Boolean']>;
  deleteCamp: Scalars['Boolean'];
  deleteDisposition: Scalars['Boolean'];
  deleteGroup: Scalars['Boolean'];
  demoteAdminToTrainer: User;
  editCamp: Camp;
  editCampDirector: Camp;
  editGroup: Group;
  editOwnParticipant: Participant;
  editParticipant: Participant;
  editTrainer: Group;
  getOneTimePassword: Scalars['Boolean'];
  importCamps: Scalars['Boolean'];
  importParticipants: Scalars['Boolean'];
  listCurrentRoleOverrides: Array<Scalars['String']>;
  loginToJMTAccountAndPushCertificate?: Maybe<Scalars['Boolean']>;
  markAsSpecialTalent?: Maybe<Scalars['Boolean']>;
  migrateExistingUserRoles: Scalars['String'];
  persistCertificates: Scalars['Boolean'];
  printCertificate: PrintCertificateResponse;
  processBackgroundRemoval: Participant;
  promoteTrainerToAdmin: User;
  removeAllParticipantsFromCamp: Scalars['Boolean'];
  removeMultipleFromGroup: Group;
  removeParticipant: Scalars['Boolean'];
  rerunPersistCertificate: Scalars['Boolean'];
  sendParticipantInviteMail: Scalars['Boolean'];
  setImage: Participant;
  shareCertificate: Scalars['String'];
  shortVote: Vote;
  signInWithOneTimePassword: Authentication;
  signinWithCode: Authentication;
  signinWithPin: Authentication;
  syncEvents: Scalars['Boolean'];
  syncGroups: Scalars['Boolean'];
  syncGroupsByCamp: Scalars['Boolean'];
  updateCampCertificateType: Camp;
  updateCampTalentCardType: Camp;
  updateDisposition: Camp;
  updateVote: Vote;
  uploadImage: Scalars['String'];
  vote: Vote;
};


export type MutationAddMultipleToGroupArgs = {
  campId: Scalars['ID'];
  groupId: Scalars['ID'];
  participantIds: Array<Scalars['ID']>;
};


export type MutationAddParticipantArgs = {
  campId: Scalars['ID'];
  input: ParticipantInput;
};


export type MutationAddToAccountAndPushCertificateArgs = {
  input: CertificateAddInput;
};


export type MutationAddToGroupArgs = {
  campId: Scalars['ID'];
  groupId: Scalars['ID'];
  participantId: Scalars['ID'];
};


export type MutationCheckJmtAccountArgs = {
  input: JmtUserInput;
};


export type MutationCreateAccountAndPushCertificateArgs = {
  input: CertificateCreateInput;
};


export type MutationCreateCampArgs = {
  input: CampInput;
};


export type MutationCreateDispositionArgs = {
  input: DispositionInput;
};


export type MutationCreateGroupArgs = {
  input: GroupInput;
};


export type MutationCreateJmtAccountAndPushCertificateArgs = {
  input: CertificateCreateWithJmtAccountInput;
};


export type MutationDeleteCampArgs = {
  campId: Scalars['ID'];
};


export type MutationDeleteDispositionArgs = {
  campId: Scalars['ID'];
  id: Scalars['Int'];
};


export type MutationDeleteGroupArgs = {
  groupId: Scalars['ID'];
};


export type MutationDemoteAdminToTrainerArgs = {
  email: Scalars['String'];
};


export type MutationEditCampArgs = {
  campId: Scalars['ID'];
  input: CampInput;
};


export type MutationEditCampDirectorArgs = {
  input: EditTrainerInput;
};


export type MutationEditGroupArgs = {
  groupId: Scalars['ID'];
  input: GroupInput;
};


export type MutationEditOwnParticipantArgs = {
  input: ParticipantInput;
  participantId: Scalars['ID'];
};


export type MutationEditParticipantArgs = {
  input: ParticipantInput;
  participantId: Scalars['ID'];
};


export type MutationEditTrainerArgs = {
  groupId: Scalars['ID'];
  input: EditTrainerInput;
};


export type MutationGetOneTimePasswordArgs = {
  input: OneTimePasswordRequestInput;
};


export type MutationImportCampsArgs = {
  input: Scalars['String'];
};


export type MutationImportParticipantsArgs = {
  campId: Scalars['ID'];
  input: Scalars['String'];
};


export type MutationLoginToJmtAccountAndPushCertificateArgs = {
  input: CertificateCreateWithJmtAccountInput;
};


export type MutationMarkAsSpecialTalentArgs = {
  campId: Scalars['ID'];
  isTalent?: InputMaybe<Scalars['Boolean']>;
  talentId: Scalars['ID'];
};


export type MutationPrintCertificateArgs = {
  participantId: Scalars['ID'];
};


export type MutationProcessBackgroundRemovalArgs = {
  participantId: Scalars['ID'];
};


export type MutationPromoteTrainerToAdminArgs = {
  email: Scalars['String'];
};


export type MutationRemoveAllParticipantsFromCampArgs = {
  campId: Scalars['ID'];
};


export type MutationRemoveMultipleFromGroupArgs = {
  campId: Scalars['ID'];
  groupId: Scalars['ID'];
  participantIds: Array<Scalars['ID']>;
};


export type MutationRemoveParticipantArgs = {
  campId: Scalars['ID'];
  participantId: Scalars['ID'];
};


export type MutationRerunPersistCertificateArgs = {
  campId: Scalars['Int'];
};


export type MutationSendParticipantInviteMailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type MutationSetImageArgs = {
  input: ImageInput;
};


export type MutationShareCertificateArgs = {
  participantId: Scalars['ID'];
};


export type MutationShortVoteArgs = {
  input: VoteInput;
  talentId: Scalars['ID'];
};


export type MutationSignInWithOneTimePasswordArgs = {
  input: AuthenticationPinInput;
};


export type MutationSigninWithCodeArgs = {
  input: AuthenticationCodeInput;
};


export type MutationSigninWithPinArgs = {
  input: AuthenticationPinInput;
};


export type MutationSyncGroupsByCampArgs = {
  campId: Scalars['Int'];
  clearCurrent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateCampCertificateTypeArgs = {
  campId: Scalars['ID'];
  certificateType: Scalars['String'];
};


export type MutationUpdateCampTalentCardTypeArgs = {
  campId: Scalars['ID'];
  talentCardType: Scalars['String'];
};


export type MutationUpdateDispositionArgs = {
  id: Scalars['Int'];
  input: DispositionInput;
};


export type MutationUpdateVoteArgs = {
  id: Scalars['ID'];
  input: VoteInput;
};


export type MutationUploadImageArgs = {
  input: Scalars['String'];
  isTalentImage?: InputMaybe<Scalars['Boolean']>;
  participantId?: InputMaybe<Scalars['ID']>;
};


export type MutationVoteArgs = {
  input: VoteInput;
  talentId: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  missingImages: Array<Camp>;
  missingVotes: Array<Camp>;
};

export type OneTimePasswordRequestInput = {
  email: Scalars['String'];
};

export type Participant = {
  __typename?: 'Participant';
  birthday?: Maybe<Scalars['String']>;
  booking_custom_checkbox_1?: Maybe<Scalars['Boolean']>;
  booking_custom_checkbox_2?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  gender?: Maybe<Gender>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageWithBackground?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  postcode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  talentClass?: Maybe<Scalars['Int']>;
  voteEnabled?: Maybe<Scalars['Boolean']>;
};

export type ParticipantInput = {
  birthday?: InputMaybe<Scalars['String']>;
  booking_custom_checkbox_1?: InputMaybe<Scalars['Boolean']>;
  booking_custom_checkbox_2?: InputMaybe<Scalars['Boolean']>;
  booking_custom_checkbox_3?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname: Scalars['String'];
  gender?: InputMaybe<Gender>;
  image?: InputMaybe<Scalars['String']>;
  lastname: Scalars['String'];
  postcode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  talentClass?: InputMaybe<Scalars['Int']>;
  voteEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type Participation = {
  __typename?: 'Participation';
  birthday?: Maybe<Scalars['String']>;
  booking_custom_checkbox_1?: Maybe<Scalars['Boolean']>;
  booking_custom_checkbox_2?: Maybe<Scalars['Boolean']>;
  booking_custom_checkbox_3?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  event: Camp;
  firstname: Scalars['String'];
  gender?: Maybe<Gender>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  postcode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  talentClass?: Maybe<Scalars['Int']>;
  voteEnabled?: Maybe<Scalars['Boolean']>;
};

export type PrintCertificateResponse = {
  __typename?: 'PrintCertificateResponse';
  printKeyOne: Scalars['String'];
  printKeyTwo: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  camp?: Maybe<Camp>;
  camps: Array<Camp>;
  certificate: Array<Certificate>;
  certificateStats: Stats;
  checkAccountAtJMT: Array<JmtUser>;
  getAllTrainers: Array<User>;
  getServerDate: Scalars['String'];
  markedSpecialTalents: Array<MarkedSpecialTalent>;
  myCamps: Array<Camp>;
  notification: Notification;
  participants: Array<Participant>;
  sharedCertificate: Certificate;
  specialTalents: Array<SpecialTalent>;
  specialTalentsDashboard: Array<MarkedSpecialTalent>;
  talent?: Maybe<Participant>;
  talentLatestVote?: Maybe<Vote>;
  votes: Array<Vote>;
  whoami: Authentication;
};


export type QueryCampArgs = {
  campId: Scalars['ID'];
};


export type QueryCampsArgs = {
  end?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type QueryCertificateStatsArgs = {
  end?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type QueryMarkedSpecialTalentsArgs = {
  campId: Scalars['ID'];
};


export type QueryMyCampsArgs = {
  end?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['String']>;
};


export type QueryParticipantsArgs = {
  campId: Scalars['ID'];
};


export type QuerySharedCertificateArgs = {
  key: Scalars['ID'];
};


export type QuerySpecialTalentsArgs = {
  campId: Scalars['ID'];
};


export type QueryTalentArgs = {
  id: Scalars['ID'];
};


export type QueryTalentLatestVoteArgs = {
  campId: Scalars['ID'];
  talentId: Scalars['ID'];
};


export type QueryVotesArgs = {
  talentId: Scalars['ID'];
};

export type SpecialTalent = {
  __typename?: 'SpecialTalent';
  birthday?: Maybe<Scalars['String']>;
  booking_custom_checkbox_1?: Maybe<Scalars['Boolean']>;
  booking_custom_checkbox_2?: Maybe<Scalars['Boolean']>;
  firstname: Scalars['String'];
  gender?: Maybe<Gender>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  talentClass?: Maybe<Scalars['Int']>;
  trainer: Array<Trainer>;
  voteEnabled?: Maybe<Scalars['Boolean']>;
};

export type Stats = {
  __typename?: 'Stats';
  count: Scalars['Int'];
  participants: Scalars['Int'];
  shared: Scalars['Int'];
  viewed: Scalars['Int'];
};

export type Talent = {
  __typename?: 'Talent';
  caption: Scalars['String'];
  id: Scalars['ID'];
  talentClass?: Maybe<Scalars['Int']>;
  voteEnabled?: Maybe<Scalars['Boolean']>;
  votes: Array<Vote>;
};

export type TalentDataView = {
  __typename?: 'TalentDataView';
  key: Scalars['Int'];
  values: Array<Scalars['Float']>;
};

export type Trainer = {
  __typename?: 'Trainer';
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  head_coach?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  birthdate?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  family_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  given_name?: Maybe<Scalars['String']>;
  isOriginalAdmin?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  sub: Scalars['String'];
};

export type Vote = {
  __typename?: 'Vote';
  campId: Scalars['ID'];
  date: Scalars['Int'];
  id: Scalars['ID'];
  talent?: Maybe<Scalars['Boolean']>;
  values: Array<Scalars['Float']>;
};

export type VoteInput = {
  class: Scalars['Int'];
  networkId: Scalars['ID'];
  talent: Scalars['Boolean'];
  values: Array<InputMaybe<Scalars['Int']>>;
};

export enum VoteType {
  ProfiVote = 'profiVote',
  ShortVote = 'shortVote'
}

export type SigninWithCodeMutationVariables = Exact<{
  input: AuthenticationCodeInput;
}>;


export type SigninWithCodeMutation = { __typename?: 'Mutation', signinWithCode: { __typename?: 'Authentication', token: string, user: { __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, gender?: string | null, birthdate?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null } } };

export type SigninWithPinMutationVariables = Exact<{
  input: AuthenticationPinInput;
}>;


export type SigninWithPinMutation = { __typename?: 'Mutation', signinWithPin: { __typename?: 'Authentication', token: string, user: { __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, gender?: string | null, birthdate?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null } } };

export type GetOneTimePasswordMutationVariables = Exact<{
  input: OneTimePasswordRequestInput;
}>;


export type GetOneTimePasswordMutation = { __typename?: 'Mutation', getOneTimePassword: boolean };

export type SignInWithOneTimePasswordMutationVariables = Exact<{
  input: AuthenticationPinInput;
}>;


export type SignInWithOneTimePasswordMutation = { __typename?: 'Mutation', signInWithOneTimePassword: { __typename?: 'Authentication', token: string, user: { __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, gender?: string | null, birthdate?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null } } };

export type WhoamiQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoamiQuery = { __typename?: 'Query', whoami: { __typename?: 'Authentication', token: string, user: { __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, gender?: string | null, birthdate?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null } } };

export type CampFragment = { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null };

export type ParticipantFragment = { __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null };

export type GroupFragment = { __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> };

export type CampsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['String']>;
}>;


export type CampsQuery = { __typename?: 'Query', camps: Array<{ __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null }> };

export type MyCampsQueryVariables = Exact<{
  start?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['String']>;
}>;


export type MyCampsQuery = { __typename?: 'Query', myCamps: Array<{ __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null }> };

export type CampQueryVariables = Exact<{
  campId: Scalars['ID'];
}>;


export type CampQuery = { __typename?: 'Query', camp?: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, groups?: Array<{ __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> }> | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } | null };

export type ParticipantsQueryVariables = Exact<{
  campId: Scalars['ID'];
}>;


export type ParticipantsQuery = { __typename?: 'Query', participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> };

export type NotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationQuery = { __typename?: 'Query', notification: { __typename?: 'Notification', missingVotes: Array<{ __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null }>, missingImages: Array<{ __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null }> } };

export type CreateGroupMutationVariables = Exact<{
  input: GroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup: { __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> } };

export type EditGroupMutationVariables = Exact<{
  input: GroupInput;
  groupId: Scalars['ID'];
}>;


export type EditGroupMutation = { __typename?: 'Mutation', editGroup: { __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> } };

export type EditTrainerMutationVariables = Exact<{
  input: EditTrainerInput;
  groupId: Scalars['ID'];
}>;


export type EditTrainerMutation = { __typename?: 'Mutation', editTrainer: { __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> } };

export type EditCampDirectorMutationVariables = Exact<{
  input: EditTrainerInput;
}>;


export type EditCampDirectorMutation = { __typename?: 'Mutation', editCampDirector: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } };

export type UpdateCampCertificateTypeMutationVariables = Exact<{
  campId: Scalars['ID'];
  certificateType: Scalars['String'];
}>;


export type UpdateCampCertificateTypeMutation = { __typename?: 'Mutation', updateCampCertificateType: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } };

export type UpdateCampTalentCardTypeMutationVariables = Exact<{
  campId: Scalars['ID'];
  talentCardType: Scalars['String'];
}>;


export type UpdateCampTalentCardTypeMutation = { __typename?: 'Mutation', updateCampTalentCardType: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } };

export type AddToGroupMutationVariables = Exact<{
  campId: Scalars['ID'];
  groupId: Scalars['ID'];
  participantId: Scalars['ID'];
}>;


export type AddToGroupMutation = { __typename?: 'Mutation', addToGroup: { __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> } };

export type AddMultipleToGroupMutationVariables = Exact<{
  campId: Scalars['ID'];
  groupId: Scalars['ID'];
  participantIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddMultipleToGroupMutation = { __typename?: 'Mutation', addMultipleToGroup: { __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> } };

export type RemoveMultipleFromGroupMutationVariables = Exact<{
  campId: Scalars['ID'];
  groupId: Scalars['ID'];
  participantIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveMultipleFromGroupMutation = { __typename?: 'Mutation', removeMultipleFromGroup: { __typename?: 'Group', id: string, name: string, missingVotes?: boolean | null, trainer?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, participants: Array<{ __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }> } };

export type DeleteGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type DeleteGroupMutation = { __typename?: 'Mutation', deleteGroup: boolean };

export type UploadImageMutationVariables = Exact<{
  input: Scalars['String'];
  isTalentImage: Scalars['Boolean'];
  participantId?: InputMaybe<Scalars['ID']>;
}>;


export type UploadImageMutation = { __typename?: 'Mutation', uploadImage: string };

export type SetImageMutationVariables = Exact<{
  input: ImageInput;
}>;


export type SetImageMutation = { __typename?: 'Mutation', setImage: { __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null } };

export type CreateDispositionMutationVariables = Exact<{
  input: DispositionInput;
}>;


export type CreateDispositionMutation = { __typename?: 'Mutation', createDisposition: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } };

export type UpdateDispositionMutationVariables = Exact<{
  id: Scalars['Int'];
  input: DispositionInput;
}>;


export type UpdateDispositionMutation = { __typename?: 'Mutation', updateDisposition: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } };

export type DeleteDispositionMutationVariables = Exact<{
  id: Scalars['Int'];
  campId: Scalars['ID'];
}>;


export type DeleteDispositionMutation = { __typename?: 'Mutation', deleteDisposition: boolean };

export type VoteFragment = { __typename?: 'Vote', id: string, values: Array<number>, talent?: boolean | null };

export type TalentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TalentQuery = { __typename?: 'Query', talent?: { __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, talentClass?: number | null } | null };

export type TalentLatestVoteQueryVariables = Exact<{
  talentId: Scalars['ID'];
  campId: Scalars['ID'];
}>;


export type TalentLatestVoteQuery = { __typename?: 'Query', talentLatestVote?: { __typename?: 'Vote', id: string, values: Array<number>, talent?: boolean | null } | null };

export type VotesQueryVariables = Exact<{
  talentId: Scalars['ID'];
}>;


export type VotesQuery = { __typename?: 'Query', votes: Array<{ __typename?: 'Vote', id: string, values: Array<number>, talent?: boolean | null }> };

export type ShortVoteMutationVariables = Exact<{
  talentId: Scalars['ID'];
  input: VoteInput;
}>;


export type ShortVoteMutation = { __typename?: 'Mutation', shortVote: { __typename?: 'Vote', id: string, values: Array<number>, talent?: boolean | null } };

export type MarkAsSpecialTalentMutationVariables = Exact<{
  talentId: Scalars['ID'];
  campId: Scalars['ID'];
  isTalent: Scalars['Boolean'];
}>;


export type MarkAsSpecialTalentMutation = { __typename?: 'Mutation', markAsSpecialTalent?: boolean | null };

export type MarkedSpecialTalentsQueryVariables = Exact<{
  campId: Scalars['ID'];
}>;


export type MarkedSpecialTalentsQuery = { __typename?: 'Query', markedSpecialTalents: Array<{ __typename?: 'MarkedSpecialTalent', isTalent: boolean, eventId: string, participant: { __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }, from: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> };

export type SpecialTalentsDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type SpecialTalentsDashboardQuery = { __typename?: 'Query', specialTalentsDashboard: Array<{ __typename?: 'MarkedSpecialTalent', isTalent: boolean, eventId: string, participant: { __typename?: 'Participant', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, imageWithBackground?: string | null, voteEnabled?: boolean | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, talentClass?: number | null }, from: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> };

export type SpecialTalentsQueryVariables = Exact<{
  campId: Scalars['ID'];
}>;


export type SpecialTalentsQuery = { __typename?: 'Query', specialTalents: Array<{ __typename?: 'SpecialTalent', id: string, firstname: string, lastname: string, birthday?: string | null, gender?: Gender | null, image?: string | null, booking_custom_checkbox_1?: boolean | null, booking_custom_checkbox_2?: boolean | null, voteEnabled?: boolean | null, talentClass?: number | null, trainer: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> }> };

export type CertificateQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificateQuery = { __typename?: 'Query', certificate: Array<{ __typename?: 'Certificate', id: string, talentId?: string | null, participantId: string, caption: string, vote: Array<number>, image?: string | null, imageWithBackground?: string | null, birthday: string, firstName: string, lastName: string, talentClass: number, camp: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } }> };

export type CheckAccountAtJmtQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckAccountAtJmtQuery = { __typename?: 'Query', checkAccountAtJMT: Array<{ __typename?: 'JmtUser', id: string, firstName: string, lastName?: string | null, email: string }> };

export type CreateAccountAndPushCertificateMutationVariables = Exact<{
  input: CertificateCreateInput;
}>;


export type CreateAccountAndPushCertificateMutation = { __typename?: 'Mutation', createAccountAndPushCertificate?: boolean | null };

export type AddToAccountAndPushCertificateMutationVariables = Exact<{
  input: CertificateAddInput;
}>;


export type AddToAccountAndPushCertificateMutation = { __typename?: 'Mutation', addToAccountAndPushCertificate?: boolean | null };

export type SharedCertificateQueryVariables = Exact<{
  key: Scalars['ID'];
}>;


export type SharedCertificateQuery = { __typename?: 'Query', sharedCertificate: { __typename?: 'Certificate', id: string, talentId?: string | null, participantId: string, caption: string, vote: Array<number>, image?: string | null, imageWithBackground?: string | null, birthday: string, firstName: string, lastName: string, talentClass: number, camp: { __typename?: 'Camp', id: string, type?: string | null, ageMax?: number | null, ageMin?: number | null, caption?: string | null, certificateType?: string | null, talentCardType?: string | null, description?: string | null, start?: string | null, end?: string | null, number?: string | null, image?: string | null, participantsCount?: number | null, finished?: boolean | null, openDispositions?: boolean | null, campDirector?: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } | null, trainers?: Array<{ __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null }> | null, dispositions?: Array<{ __typename?: 'Disposition', id: string, status: DispositionStatus, note_to_organizers?: string | null, trainer: { __typename?: 'Trainer', id: string, firstname?: string | null, lastname?: string | null, email: string, head_coach?: boolean | null } }> | null } } };

export type ShareCertificateMutationVariables = Exact<{
  participantId: Scalars['ID'];
}>;


export type ShareCertificateMutation = { __typename?: 'Mutation', shareCertificate: string };

export type RerunPersistCertificateMutationVariables = Exact<{
  campId: Scalars['Int'];
}>;


export type RerunPersistCertificateMutation = { __typename?: 'Mutation', rerunPersistCertificate: boolean };

export type PrintCertificateMutationVariables = Exact<{
  participantId: Scalars['ID'];
}>;


export type PrintCertificateMutation = { __typename?: 'Mutation', printCertificate: { __typename?: 'PrintCertificateResponse', printKeyOne: string, printKeyTwo: string } };

export type CheckJmtAccountMutationVariables = Exact<{
  input: JmtUserInput;
}>;


export type CheckJmtAccountMutation = { __typename?: 'Mutation', checkJMTAccount?: { __typename?: 'JmtUser', id: string, firstName: string, lastName?: string | null, email: string } | null };

export type LoginToJmtAccountAndPushCertificateMutationVariables = Exact<{
  input: CertificateCreateWithJmtAccountInput;
}>;


export type LoginToJmtAccountAndPushCertificateMutation = { __typename?: 'Mutation', loginToJMTAccountAndPushCertificate?: boolean | null };

export type CreateJmtAccountAndPushCertificateMutationVariables = Exact<{
  input: CertificateCreateWithJmtAccountInput;
}>;


export type CreateJmtAccountAndPushCertificateMutation = { __typename?: 'Mutation', createJMTAccountAndPushCertificate?: boolean | null };

export type UserFragment = { __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, gender?: string | null, birthdate?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null };

export type GetAllTrainersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTrainersQuery = { __typename?: 'Query', getAllTrainers: Array<{ __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null }> };

export type PromoteTrainerToAdminMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type PromoteTrainerToAdminMutation = { __typename?: 'Mutation', promoteTrainerToAdmin: { __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, gender?: string | null, birthdate?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null } };

export type DemoteAdminToTrainerMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DemoteAdminToTrainerMutation = { __typename?: 'Mutation', demoteAdminToTrainer: { __typename?: 'User', sub: string, given_name?: string | null, family_name?: string | null, name?: string | null, gender?: string | null, birthdate?: string | null, email: string, roles: Array<string>, isOriginalAdmin?: boolean | null } };

export const CampFragmentDoc = gql`
    fragment camp on Camp {
  id
  type
  ageMax
  ageMin
  caption
  certificateType
  talentCardType
  description
  start
  end
  number
  image
  participantsCount
  finished
  campDirector {
    id
    firstname
    lastname
    email
    head_coach
  }
  trainers {
    id
    firstname
    lastname
    email
    head_coach
  }
  openDispositions
  dispositions {
    id
    status
    note_to_organizers
    trainer {
      id
      firstname
      lastname
      email
      head_coach
    }
  }
}
    `;
export const ParticipantFragmentDoc = gql`
    fragment participant on Participant {
  id
  firstname
  lastname
  birthday
  gender
  image
  imageWithBackground
  voteEnabled
  booking_custom_checkbox_1
  booking_custom_checkbox_2
  talentClass
}
    `;
export const GroupFragmentDoc = gql`
    fragment group on Group {
  id
  name
  trainer {
    id
    firstname
    lastname
    email
    head_coach
  }
  participants {
    ...participant
  }
  missingVotes
}
    ${ParticipantFragmentDoc}`;
export const VoteFragmentDoc = gql`
    fragment vote on Vote {
  id
  values
  talent
}
    `;
export const UserFragmentDoc = gql`
    fragment user on User {
  sub
  given_name
  family_name
  name
  gender
  birthdate
  email
  roles
  isOriginalAdmin
}
    `;
export const SigninWithCodeDocument = gql`
    mutation signinWithCode($input: AuthenticationCodeInput!) {
  signinWithCode(input: $input) {
    token
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type SigninWithCodeMutationFn = Apollo.MutationFunction<SigninWithCodeMutation, SigninWithCodeMutationVariables>;

/**
 * __useSigninWithCodeMutation__
 *
 * To run a mutation, you first call `useSigninWithCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninWithCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinWithCodeMutation, { data, loading, error }] = useSigninWithCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSigninWithCodeMutation(baseOptions?: Apollo.MutationHookOptions<SigninWithCodeMutation, SigninWithCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninWithCodeMutation, SigninWithCodeMutationVariables>(SigninWithCodeDocument, options);
      }
export type SigninWithCodeMutationHookResult = ReturnType<typeof useSigninWithCodeMutation>;
export type SigninWithCodeMutationResult = Apollo.MutationResult<SigninWithCodeMutation>;
export type SigninWithCodeMutationOptions = Apollo.BaseMutationOptions<SigninWithCodeMutation, SigninWithCodeMutationVariables>;
export const SigninWithPinDocument = gql`
    mutation signinWithPin($input: AuthenticationPinInput!) {
  signinWithPin(input: $input) {
    token
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type SigninWithPinMutationFn = Apollo.MutationFunction<SigninWithPinMutation, SigninWithPinMutationVariables>;

/**
 * __useSigninWithPinMutation__
 *
 * To run a mutation, you first call `useSigninWithPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninWithPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinWithPinMutation, { data, loading, error }] = useSigninWithPinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSigninWithPinMutation(baseOptions?: Apollo.MutationHookOptions<SigninWithPinMutation, SigninWithPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SigninWithPinMutation, SigninWithPinMutationVariables>(SigninWithPinDocument, options);
      }
export type SigninWithPinMutationHookResult = ReturnType<typeof useSigninWithPinMutation>;
export type SigninWithPinMutationResult = Apollo.MutationResult<SigninWithPinMutation>;
export type SigninWithPinMutationOptions = Apollo.BaseMutationOptions<SigninWithPinMutation, SigninWithPinMutationVariables>;
export const GetOneTimePasswordDocument = gql`
    mutation getOneTimePassword($input: OneTimePasswordRequestInput!) {
  getOneTimePassword(input: $input)
}
    `;
export type GetOneTimePasswordMutationFn = Apollo.MutationFunction<GetOneTimePasswordMutation, GetOneTimePasswordMutationVariables>;

/**
 * __useGetOneTimePasswordMutation__
 *
 * To run a mutation, you first call `useGetOneTimePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOneTimePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOneTimePasswordMutation, { data, loading, error }] = useGetOneTimePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOneTimePasswordMutation(baseOptions?: Apollo.MutationHookOptions<GetOneTimePasswordMutation, GetOneTimePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOneTimePasswordMutation, GetOneTimePasswordMutationVariables>(GetOneTimePasswordDocument, options);
      }
export type GetOneTimePasswordMutationHookResult = ReturnType<typeof useGetOneTimePasswordMutation>;
export type GetOneTimePasswordMutationResult = Apollo.MutationResult<GetOneTimePasswordMutation>;
export type GetOneTimePasswordMutationOptions = Apollo.BaseMutationOptions<GetOneTimePasswordMutation, GetOneTimePasswordMutationVariables>;
export const SignInWithOneTimePasswordDocument = gql`
    mutation signInWithOneTimePassword($input: AuthenticationPinInput!) {
  signInWithOneTimePassword(input: $input) {
    token
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;
export type SignInWithOneTimePasswordMutationFn = Apollo.MutationFunction<SignInWithOneTimePasswordMutation, SignInWithOneTimePasswordMutationVariables>;

/**
 * __useSignInWithOneTimePasswordMutation__
 *
 * To run a mutation, you first call `useSignInWithOneTimePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInWithOneTimePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInWithOneTimePasswordMutation, { data, loading, error }] = useSignInWithOneTimePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInWithOneTimePasswordMutation(baseOptions?: Apollo.MutationHookOptions<SignInWithOneTimePasswordMutation, SignInWithOneTimePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInWithOneTimePasswordMutation, SignInWithOneTimePasswordMutationVariables>(SignInWithOneTimePasswordDocument, options);
      }
export type SignInWithOneTimePasswordMutationHookResult = ReturnType<typeof useSignInWithOneTimePasswordMutation>;
export type SignInWithOneTimePasswordMutationResult = Apollo.MutationResult<SignInWithOneTimePasswordMutation>;
export type SignInWithOneTimePasswordMutationOptions = Apollo.BaseMutationOptions<SignInWithOneTimePasswordMutation, SignInWithOneTimePasswordMutationVariables>;
export const WhoamiDocument = gql`
    query whoami {
  whoami {
    token
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useWhoamiQuery__
 *
 * To run a query within a React component, call `useWhoamiQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoamiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoamiQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoamiQuery(baseOptions?: Apollo.QueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
      }
export function useWhoamiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoamiQuery, WhoamiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoamiQuery, WhoamiQueryVariables>(WhoamiDocument, options);
        }
export type WhoamiQueryHookResult = ReturnType<typeof useWhoamiQuery>;
export type WhoamiLazyQueryHookResult = ReturnType<typeof useWhoamiLazyQuery>;
export type WhoamiQueryResult = Apollo.QueryResult<WhoamiQuery, WhoamiQueryVariables>;
export const CampsDocument = gql`
    query camps($start: String, $end: String) {
  camps(start: $start, end: $end) {
    ...camp
  }
}
    ${CampFragmentDoc}`;

/**
 * __useCampsQuery__
 *
 * To run a query within a React component, call `useCampsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useCampsQuery(baseOptions?: Apollo.QueryHookOptions<CampsQuery, CampsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampsQuery, CampsQueryVariables>(CampsDocument, options);
      }
export function useCampsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampsQuery, CampsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampsQuery, CampsQueryVariables>(CampsDocument, options);
        }
export type CampsQueryHookResult = ReturnType<typeof useCampsQuery>;
export type CampsLazyQueryHookResult = ReturnType<typeof useCampsLazyQuery>;
export type CampsQueryResult = Apollo.QueryResult<CampsQuery, CampsQueryVariables>;
export const MyCampsDocument = gql`
    query myCamps($start: String, $end: String) {
  myCamps(start: $start, end: $end) {
    ...camp
  }
}
    ${CampFragmentDoc}`;

/**
 * __useMyCampsQuery__
 *
 * To run a query within a React component, call `useMyCampsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCampsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCampsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useMyCampsQuery(baseOptions?: Apollo.QueryHookOptions<MyCampsQuery, MyCampsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCampsQuery, MyCampsQueryVariables>(MyCampsDocument, options);
      }
export function useMyCampsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCampsQuery, MyCampsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCampsQuery, MyCampsQueryVariables>(MyCampsDocument, options);
        }
export type MyCampsQueryHookResult = ReturnType<typeof useMyCampsQuery>;
export type MyCampsLazyQueryHookResult = ReturnType<typeof useMyCampsLazyQuery>;
export type MyCampsQueryResult = Apollo.QueryResult<MyCampsQuery, MyCampsQueryVariables>;
export const CampDocument = gql`
    query camp($campId: ID!) {
  camp(campId: $campId) {
    ...camp
    groups {
      ...group
    }
  }
}
    ${CampFragmentDoc}
${GroupFragmentDoc}`;

/**
 * __useCampQuery__
 *
 * To run a query within a React component, call `useCampQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampQuery({
 *   variables: {
 *      campId: // value for 'campId'
 *   },
 * });
 */
export function useCampQuery(baseOptions: Apollo.QueryHookOptions<CampQuery, CampQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampQuery, CampQueryVariables>(CampDocument, options);
      }
export function useCampLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampQuery, CampQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampQuery, CampQueryVariables>(CampDocument, options);
        }
export type CampQueryHookResult = ReturnType<typeof useCampQuery>;
export type CampLazyQueryHookResult = ReturnType<typeof useCampLazyQuery>;
export type CampQueryResult = Apollo.QueryResult<CampQuery, CampQueryVariables>;
export const ParticipantsDocument = gql`
    query participants($campId: ID!) {
  participants(campId: $campId) {
    ...participant
  }
}
    ${ParticipantFragmentDoc}`;

/**
 * __useParticipantsQuery__
 *
 * To run a query within a React component, call `useParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantsQuery({
 *   variables: {
 *      campId: // value for 'campId'
 *   },
 * });
 */
export function useParticipantsQuery(baseOptions: Apollo.QueryHookOptions<ParticipantsQuery, ParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantsQuery, ParticipantsQueryVariables>(ParticipantsDocument, options);
      }
export function useParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantsQuery, ParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantsQuery, ParticipantsQueryVariables>(ParticipantsDocument, options);
        }
export type ParticipantsQueryHookResult = ReturnType<typeof useParticipantsQuery>;
export type ParticipantsLazyQueryHookResult = ReturnType<typeof useParticipantsLazyQuery>;
export type ParticipantsQueryResult = Apollo.QueryResult<ParticipantsQuery, ParticipantsQueryVariables>;
export const NotificationDocument = gql`
    query notification {
  notification {
    missingVotes {
      ...camp
    }
    missingImages {
      ...camp
    }
  }
}
    ${CampFragmentDoc}`;

/**
 * __useNotificationQuery__
 *
 * To run a query within a React component, call `useNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationQuery(baseOptions?: Apollo.QueryHookOptions<NotificationQuery, NotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationQuery, NotificationQueryVariables>(NotificationDocument, options);
      }
export function useNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationQuery, NotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationQuery, NotificationQueryVariables>(NotificationDocument, options);
        }
export type NotificationQueryHookResult = ReturnType<typeof useNotificationQuery>;
export type NotificationLazyQueryHookResult = ReturnType<typeof useNotificationLazyQuery>;
export type NotificationQueryResult = Apollo.QueryResult<NotificationQuery, NotificationQueryVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($input: GroupInput!) {
  createGroup(input: $input) {
    ...group
  }
}
    ${GroupFragmentDoc}`;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const EditGroupDocument = gql`
    mutation editGroup($input: GroupInput!, $groupId: ID!) {
  editGroup(input: $input, groupId: $groupId) {
    ...group
  }
}
    ${GroupFragmentDoc}`;
export type EditGroupMutationFn = Apollo.MutationFunction<EditGroupMutation, EditGroupMutationVariables>;

/**
 * __useEditGroupMutation__
 *
 * To run a mutation, you first call `useEditGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGroupMutation, { data, loading, error }] = useEditGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useEditGroupMutation(baseOptions?: Apollo.MutationHookOptions<EditGroupMutation, EditGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGroupMutation, EditGroupMutationVariables>(EditGroupDocument, options);
      }
export type EditGroupMutationHookResult = ReturnType<typeof useEditGroupMutation>;
export type EditGroupMutationResult = Apollo.MutationResult<EditGroupMutation>;
export type EditGroupMutationOptions = Apollo.BaseMutationOptions<EditGroupMutation, EditGroupMutationVariables>;
export const EditTrainerDocument = gql`
    mutation editTrainer($input: EditTrainerInput!, $groupId: ID!) {
  editTrainer(input: $input, groupId: $groupId) {
    ...group
  }
}
    ${GroupFragmentDoc}`;
export type EditTrainerMutationFn = Apollo.MutationFunction<EditTrainerMutation, EditTrainerMutationVariables>;

/**
 * __useEditTrainerMutation__
 *
 * To run a mutation, you first call `useEditTrainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTrainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTrainerMutation, { data, loading, error }] = useEditTrainerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useEditTrainerMutation(baseOptions?: Apollo.MutationHookOptions<EditTrainerMutation, EditTrainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTrainerMutation, EditTrainerMutationVariables>(EditTrainerDocument, options);
      }
export type EditTrainerMutationHookResult = ReturnType<typeof useEditTrainerMutation>;
export type EditTrainerMutationResult = Apollo.MutationResult<EditTrainerMutation>;
export type EditTrainerMutationOptions = Apollo.BaseMutationOptions<EditTrainerMutation, EditTrainerMutationVariables>;
export const EditCampDirectorDocument = gql`
    mutation editCampDirector($input: EditTrainerInput!) {
  editCampDirector(input: $input) {
    ...camp
  }
}
    ${CampFragmentDoc}`;
export type EditCampDirectorMutationFn = Apollo.MutationFunction<EditCampDirectorMutation, EditCampDirectorMutationVariables>;

/**
 * __useEditCampDirectorMutation__
 *
 * To run a mutation, you first call `useEditCampDirectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCampDirectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCampDirectorMutation, { data, loading, error }] = useEditCampDirectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCampDirectorMutation(baseOptions?: Apollo.MutationHookOptions<EditCampDirectorMutation, EditCampDirectorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCampDirectorMutation, EditCampDirectorMutationVariables>(EditCampDirectorDocument, options);
      }
export type EditCampDirectorMutationHookResult = ReturnType<typeof useEditCampDirectorMutation>;
export type EditCampDirectorMutationResult = Apollo.MutationResult<EditCampDirectorMutation>;
export type EditCampDirectorMutationOptions = Apollo.BaseMutationOptions<EditCampDirectorMutation, EditCampDirectorMutationVariables>;
export const UpdateCampCertificateTypeDocument = gql`
    mutation updateCampCertificateType($campId: ID!, $certificateType: String!) {
  updateCampCertificateType(campId: $campId, certificateType: $certificateType) {
    ...camp
  }
}
    ${CampFragmentDoc}`;
export type UpdateCampCertificateTypeMutationFn = Apollo.MutationFunction<UpdateCampCertificateTypeMutation, UpdateCampCertificateTypeMutationVariables>;

/**
 * __useUpdateCampCertificateTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCampCertificateTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampCertificateTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampCertificateTypeMutation, { data, loading, error }] = useUpdateCampCertificateTypeMutation({
 *   variables: {
 *      campId: // value for 'campId'
 *      certificateType: // value for 'certificateType'
 *   },
 * });
 */
export function useUpdateCampCertificateTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampCertificateTypeMutation, UpdateCampCertificateTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampCertificateTypeMutation, UpdateCampCertificateTypeMutationVariables>(UpdateCampCertificateTypeDocument, options);
      }
export type UpdateCampCertificateTypeMutationHookResult = ReturnType<typeof useUpdateCampCertificateTypeMutation>;
export type UpdateCampCertificateTypeMutationResult = Apollo.MutationResult<UpdateCampCertificateTypeMutation>;
export type UpdateCampCertificateTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCampCertificateTypeMutation, UpdateCampCertificateTypeMutationVariables>;
export const UpdateCampTalentCardTypeDocument = gql`
    mutation updateCampTalentCardType($campId: ID!, $talentCardType: String!) {
  updateCampTalentCardType(campId: $campId, talentCardType: $talentCardType) {
    ...camp
  }
}
    ${CampFragmentDoc}`;
export type UpdateCampTalentCardTypeMutationFn = Apollo.MutationFunction<UpdateCampTalentCardTypeMutation, UpdateCampTalentCardTypeMutationVariables>;

/**
 * __useUpdateCampTalentCardTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCampTalentCardTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampTalentCardTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampTalentCardTypeMutation, { data, loading, error }] = useUpdateCampTalentCardTypeMutation({
 *   variables: {
 *      campId: // value for 'campId'
 *      talentCardType: // value for 'talentCardType'
 *   },
 * });
 */
export function useUpdateCampTalentCardTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampTalentCardTypeMutation, UpdateCampTalentCardTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampTalentCardTypeMutation, UpdateCampTalentCardTypeMutationVariables>(UpdateCampTalentCardTypeDocument, options);
      }
export type UpdateCampTalentCardTypeMutationHookResult = ReturnType<typeof useUpdateCampTalentCardTypeMutation>;
export type UpdateCampTalentCardTypeMutationResult = Apollo.MutationResult<UpdateCampTalentCardTypeMutation>;
export type UpdateCampTalentCardTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCampTalentCardTypeMutation, UpdateCampTalentCardTypeMutationVariables>;
export const AddToGroupDocument = gql`
    mutation addToGroup($campId: ID!, $groupId: ID!, $participantId: ID!) {
  addToGroup(campId: $campId, groupId: $groupId, participantId: $participantId) {
    ...group
  }
}
    ${GroupFragmentDoc}`;
export type AddToGroupMutationFn = Apollo.MutationFunction<AddToGroupMutation, AddToGroupMutationVariables>;

/**
 * __useAddToGroupMutation__
 *
 * To run a mutation, you first call `useAddToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToGroupMutation, { data, loading, error }] = useAddToGroupMutation({
 *   variables: {
 *      campId: // value for 'campId'
 *      groupId: // value for 'groupId'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useAddToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddToGroupMutation, AddToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToGroupMutation, AddToGroupMutationVariables>(AddToGroupDocument, options);
      }
export type AddToGroupMutationHookResult = ReturnType<typeof useAddToGroupMutation>;
export type AddToGroupMutationResult = Apollo.MutationResult<AddToGroupMutation>;
export type AddToGroupMutationOptions = Apollo.BaseMutationOptions<AddToGroupMutation, AddToGroupMutationVariables>;
export const AddMultipleToGroupDocument = gql`
    mutation addMultipleToGroup($campId: ID!, $groupId: ID!, $participantIds: [ID!]!) {
  addMultipleToGroup(
    campId: $campId
    groupId: $groupId
    participantIds: $participantIds
  ) {
    ...group
  }
}
    ${GroupFragmentDoc}`;
export type AddMultipleToGroupMutationFn = Apollo.MutationFunction<AddMultipleToGroupMutation, AddMultipleToGroupMutationVariables>;

/**
 * __useAddMultipleToGroupMutation__
 *
 * To run a mutation, you first call `useAddMultipleToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMultipleToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMultipleToGroupMutation, { data, loading, error }] = useAddMultipleToGroupMutation({
 *   variables: {
 *      campId: // value for 'campId'
 *      groupId: // value for 'groupId'
 *      participantIds: // value for 'participantIds'
 *   },
 * });
 */
export function useAddMultipleToGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddMultipleToGroupMutation, AddMultipleToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMultipleToGroupMutation, AddMultipleToGroupMutationVariables>(AddMultipleToGroupDocument, options);
      }
export type AddMultipleToGroupMutationHookResult = ReturnType<typeof useAddMultipleToGroupMutation>;
export type AddMultipleToGroupMutationResult = Apollo.MutationResult<AddMultipleToGroupMutation>;
export type AddMultipleToGroupMutationOptions = Apollo.BaseMutationOptions<AddMultipleToGroupMutation, AddMultipleToGroupMutationVariables>;
export const RemoveMultipleFromGroupDocument = gql`
    mutation removeMultipleFromGroup($campId: ID!, $groupId: ID!, $participantIds: [ID!]!) {
  removeMultipleFromGroup(
    campId: $campId
    groupId: $groupId
    participantIds: $participantIds
  ) {
    ...group
  }
}
    ${GroupFragmentDoc}`;
export type RemoveMultipleFromGroupMutationFn = Apollo.MutationFunction<RemoveMultipleFromGroupMutation, RemoveMultipleFromGroupMutationVariables>;

/**
 * __useRemoveMultipleFromGroupMutation__
 *
 * To run a mutation, you first call `useRemoveMultipleFromGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMultipleFromGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMultipleFromGroupMutation, { data, loading, error }] = useRemoveMultipleFromGroupMutation({
 *   variables: {
 *      campId: // value for 'campId'
 *      groupId: // value for 'groupId'
 *      participantIds: // value for 'participantIds'
 *   },
 * });
 */
export function useRemoveMultipleFromGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMultipleFromGroupMutation, RemoveMultipleFromGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMultipleFromGroupMutation, RemoveMultipleFromGroupMutationVariables>(RemoveMultipleFromGroupDocument, options);
      }
export type RemoveMultipleFromGroupMutationHookResult = ReturnType<typeof useRemoveMultipleFromGroupMutation>;
export type RemoveMultipleFromGroupMutationResult = Apollo.MutationResult<RemoveMultipleFromGroupMutation>;
export type RemoveMultipleFromGroupMutationOptions = Apollo.BaseMutationOptions<RemoveMultipleFromGroupMutation, RemoveMultipleFromGroupMutationVariables>;
export const DeleteGroupDocument = gql`
    mutation deleteGroup($groupId: ID!) {
  deleteGroup(groupId: $groupId)
}
    `;
export type DeleteGroupMutationFn = Apollo.MutationFunction<DeleteGroupMutation, DeleteGroupMutationVariables>;

/**
 * __useDeleteGroupMutation__
 *
 * To run a mutation, you first call `useDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupMutation, { data, loading, error }] = useDeleteGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDeleteGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupMutation, DeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupMutation, DeleteGroupMutationVariables>(DeleteGroupDocument, options);
      }
export type DeleteGroupMutationHookResult = ReturnType<typeof useDeleteGroupMutation>;
export type DeleteGroupMutationResult = Apollo.MutationResult<DeleteGroupMutation>;
export type DeleteGroupMutationOptions = Apollo.BaseMutationOptions<DeleteGroupMutation, DeleteGroupMutationVariables>;
export const UploadImageDocument = gql`
    mutation uploadImage($input: String!, $isTalentImage: Boolean!, $participantId: ID) {
  uploadImage(
    input: $input
    isTalentImage: $isTalentImage
    participantId: $participantId
  )
}
    `;
export type UploadImageMutationFn = Apollo.MutationFunction<UploadImageMutation, UploadImageMutationVariables>;

/**
 * __useUploadImageMutation__
 *
 * To run a mutation, you first call `useUploadImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageMutation, { data, loading, error }] = useUploadImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isTalentImage: // value for 'isTalentImage'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useUploadImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageMutation, UploadImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageMutation, UploadImageMutationVariables>(UploadImageDocument, options);
      }
export type UploadImageMutationHookResult = ReturnType<typeof useUploadImageMutation>;
export type UploadImageMutationResult = Apollo.MutationResult<UploadImageMutation>;
export type UploadImageMutationOptions = Apollo.BaseMutationOptions<UploadImageMutation, UploadImageMutationVariables>;
export const SetImageDocument = gql`
    mutation setImage($input: ImageInput!) {
  setImage(input: $input) {
    ...participant
  }
}
    ${ParticipantFragmentDoc}`;
export type SetImageMutationFn = Apollo.MutationFunction<SetImageMutation, SetImageMutationVariables>;

/**
 * __useSetImageMutation__
 *
 * To run a mutation, you first call `useSetImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setImageMutation, { data, loading, error }] = useSetImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetImageMutation(baseOptions?: Apollo.MutationHookOptions<SetImageMutation, SetImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetImageMutation, SetImageMutationVariables>(SetImageDocument, options);
      }
export type SetImageMutationHookResult = ReturnType<typeof useSetImageMutation>;
export type SetImageMutationResult = Apollo.MutationResult<SetImageMutation>;
export type SetImageMutationOptions = Apollo.BaseMutationOptions<SetImageMutation, SetImageMutationVariables>;
export const CreateDispositionDocument = gql`
    mutation createDisposition($input: DispositionInput!) {
  createDisposition(input: $input) {
    ...camp
  }
}
    ${CampFragmentDoc}`;
export type CreateDispositionMutationFn = Apollo.MutationFunction<CreateDispositionMutation, CreateDispositionMutationVariables>;

/**
 * __useCreateDispositionMutation__
 *
 * To run a mutation, you first call `useCreateDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDispositionMutation, { data, loading, error }] = useCreateDispositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDispositionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDispositionMutation, CreateDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDispositionMutation, CreateDispositionMutationVariables>(CreateDispositionDocument, options);
      }
export type CreateDispositionMutationHookResult = ReturnType<typeof useCreateDispositionMutation>;
export type CreateDispositionMutationResult = Apollo.MutationResult<CreateDispositionMutation>;
export type CreateDispositionMutationOptions = Apollo.BaseMutationOptions<CreateDispositionMutation, CreateDispositionMutationVariables>;
export const UpdateDispositionDocument = gql`
    mutation updateDisposition($id: Int!, $input: DispositionInput!) {
  updateDisposition(id: $id, input: $input) {
    ...camp
  }
}
    ${CampFragmentDoc}`;
export type UpdateDispositionMutationFn = Apollo.MutationFunction<UpdateDispositionMutation, UpdateDispositionMutationVariables>;

/**
 * __useUpdateDispositionMutation__
 *
 * To run a mutation, you first call `useUpdateDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDispositionMutation, { data, loading, error }] = useUpdateDispositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDispositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDispositionMutation, UpdateDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDispositionMutation, UpdateDispositionMutationVariables>(UpdateDispositionDocument, options);
      }
export type UpdateDispositionMutationHookResult = ReturnType<typeof useUpdateDispositionMutation>;
export type UpdateDispositionMutationResult = Apollo.MutationResult<UpdateDispositionMutation>;
export type UpdateDispositionMutationOptions = Apollo.BaseMutationOptions<UpdateDispositionMutation, UpdateDispositionMutationVariables>;
export const DeleteDispositionDocument = gql`
    mutation deleteDisposition($id: Int!, $campId: ID!) {
  deleteDisposition(id: $id, campId: $campId)
}
    `;
export type DeleteDispositionMutationFn = Apollo.MutationFunction<DeleteDispositionMutation, DeleteDispositionMutationVariables>;

/**
 * __useDeleteDispositionMutation__
 *
 * To run a mutation, you first call `useDeleteDispositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDispositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDispositionMutation, { data, loading, error }] = useDeleteDispositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      campId: // value for 'campId'
 *   },
 * });
 */
export function useDeleteDispositionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDispositionMutation, DeleteDispositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDispositionMutation, DeleteDispositionMutationVariables>(DeleteDispositionDocument, options);
      }
export type DeleteDispositionMutationHookResult = ReturnType<typeof useDeleteDispositionMutation>;
export type DeleteDispositionMutationResult = Apollo.MutationResult<DeleteDispositionMutation>;
export type DeleteDispositionMutationOptions = Apollo.BaseMutationOptions<DeleteDispositionMutation, DeleteDispositionMutationVariables>;
export const TalentDocument = gql`
    query talent($id: ID!) {
  talent(id: $id) {
    id
    firstname
    lastname
    birthday
    gender
    image
    imageWithBackground
    talentClass
  }
}
    `;

/**
 * __useTalentQuery__
 *
 * To run a query within a React component, call `useTalentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTalentQuery(baseOptions: Apollo.QueryHookOptions<TalentQuery, TalentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentQuery, TalentQueryVariables>(TalentDocument, options);
      }
export function useTalentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentQuery, TalentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentQuery, TalentQueryVariables>(TalentDocument, options);
        }
export type TalentQueryHookResult = ReturnType<typeof useTalentQuery>;
export type TalentLazyQueryHookResult = ReturnType<typeof useTalentLazyQuery>;
export type TalentQueryResult = Apollo.QueryResult<TalentQuery, TalentQueryVariables>;
export const TalentLatestVoteDocument = gql`
    query talentLatestVote($talentId: ID!, $campId: ID!) {
  talentLatestVote(talentId: $talentId, campId: $campId) {
    ...vote
  }
}
    ${VoteFragmentDoc}`;

/**
 * __useTalentLatestVoteQuery__
 *
 * To run a query within a React component, call `useTalentLatestVoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTalentLatestVoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTalentLatestVoteQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      campId: // value for 'campId'
 *   },
 * });
 */
export function useTalentLatestVoteQuery(baseOptions: Apollo.QueryHookOptions<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>(TalentLatestVoteDocument, options);
      }
export function useTalentLatestVoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>(TalentLatestVoteDocument, options);
        }
export type TalentLatestVoteQueryHookResult = ReturnType<typeof useTalentLatestVoteQuery>;
export type TalentLatestVoteLazyQueryHookResult = ReturnType<typeof useTalentLatestVoteLazyQuery>;
export type TalentLatestVoteQueryResult = Apollo.QueryResult<TalentLatestVoteQuery, TalentLatestVoteQueryVariables>;
export const VotesDocument = gql`
    query votes($talentId: ID!) {
  votes(talentId: $talentId) {
    ...vote
  }
}
    ${VoteFragmentDoc}`;

/**
 * __useVotesQuery__
 *
 * To run a query within a React component, call `useVotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVotesQuery({
 *   variables: {
 *      talentId: // value for 'talentId'
 *   },
 * });
 */
export function useVotesQuery(baseOptions: Apollo.QueryHookOptions<VotesQuery, VotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VotesQuery, VotesQueryVariables>(VotesDocument, options);
      }
export function useVotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VotesQuery, VotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VotesQuery, VotesQueryVariables>(VotesDocument, options);
        }
export type VotesQueryHookResult = ReturnType<typeof useVotesQuery>;
export type VotesLazyQueryHookResult = ReturnType<typeof useVotesLazyQuery>;
export type VotesQueryResult = Apollo.QueryResult<VotesQuery, VotesQueryVariables>;
export const ShortVoteDocument = gql`
    mutation shortVote($talentId: ID!, $input: VoteInput!) {
  shortVote(talentId: $talentId, input: $input) {
    ...vote
  }
}
    ${VoteFragmentDoc}`;
export type ShortVoteMutationFn = Apollo.MutationFunction<ShortVoteMutation, ShortVoteMutationVariables>;

/**
 * __useShortVoteMutation__
 *
 * To run a mutation, you first call `useShortVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortVoteMutation, { data, loading, error }] = useShortVoteMutation({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShortVoteMutation(baseOptions?: Apollo.MutationHookOptions<ShortVoteMutation, ShortVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShortVoteMutation, ShortVoteMutationVariables>(ShortVoteDocument, options);
      }
export type ShortVoteMutationHookResult = ReturnType<typeof useShortVoteMutation>;
export type ShortVoteMutationResult = Apollo.MutationResult<ShortVoteMutation>;
export type ShortVoteMutationOptions = Apollo.BaseMutationOptions<ShortVoteMutation, ShortVoteMutationVariables>;
export const MarkAsSpecialTalentDocument = gql`
    mutation markAsSpecialTalent($talentId: ID!, $campId: ID!, $isTalent: Boolean!) {
  markAsSpecialTalent(talentId: $talentId, campId: $campId, isTalent: $isTalent)
}
    `;
export type MarkAsSpecialTalentMutationFn = Apollo.MutationFunction<MarkAsSpecialTalentMutation, MarkAsSpecialTalentMutationVariables>;

/**
 * __useMarkAsSpecialTalentMutation__
 *
 * To run a mutation, you first call `useMarkAsSpecialTalentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsSpecialTalentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsSpecialTalentMutation, { data, loading, error }] = useMarkAsSpecialTalentMutation({
 *   variables: {
 *      talentId: // value for 'talentId'
 *      campId: // value for 'campId'
 *      isTalent: // value for 'isTalent'
 *   },
 * });
 */
export function useMarkAsSpecialTalentMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsSpecialTalentMutation, MarkAsSpecialTalentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsSpecialTalentMutation, MarkAsSpecialTalentMutationVariables>(MarkAsSpecialTalentDocument, options);
      }
export type MarkAsSpecialTalentMutationHookResult = ReturnType<typeof useMarkAsSpecialTalentMutation>;
export type MarkAsSpecialTalentMutationResult = Apollo.MutationResult<MarkAsSpecialTalentMutation>;
export type MarkAsSpecialTalentMutationOptions = Apollo.BaseMutationOptions<MarkAsSpecialTalentMutation, MarkAsSpecialTalentMutationVariables>;
export const MarkedSpecialTalentsDocument = gql`
    query markedSpecialTalents($campId: ID!) {
  markedSpecialTalents(campId: $campId) {
    isTalent
    participant {
      ...participant
    }
    eventId
    from {
      id
      firstname
      lastname
      email
      head_coach
    }
  }
}
    ${ParticipantFragmentDoc}`;

/**
 * __useMarkedSpecialTalentsQuery__
 *
 * To run a query within a React component, call `useMarkedSpecialTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkedSpecialTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkedSpecialTalentsQuery({
 *   variables: {
 *      campId: // value for 'campId'
 *   },
 * });
 */
export function useMarkedSpecialTalentsQuery(baseOptions: Apollo.QueryHookOptions<MarkedSpecialTalentsQuery, MarkedSpecialTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarkedSpecialTalentsQuery, MarkedSpecialTalentsQueryVariables>(MarkedSpecialTalentsDocument, options);
      }
export function useMarkedSpecialTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarkedSpecialTalentsQuery, MarkedSpecialTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarkedSpecialTalentsQuery, MarkedSpecialTalentsQueryVariables>(MarkedSpecialTalentsDocument, options);
        }
export type MarkedSpecialTalentsQueryHookResult = ReturnType<typeof useMarkedSpecialTalentsQuery>;
export type MarkedSpecialTalentsLazyQueryHookResult = ReturnType<typeof useMarkedSpecialTalentsLazyQuery>;
export type MarkedSpecialTalentsQueryResult = Apollo.QueryResult<MarkedSpecialTalentsQuery, MarkedSpecialTalentsQueryVariables>;
export const SpecialTalentsDashboardDocument = gql`
    query specialTalentsDashboard {
  specialTalentsDashboard {
    isTalent
    participant {
      ...participant
    }
    eventId
    from {
      id
      firstname
      lastname
      email
      head_coach
    }
  }
}
    ${ParticipantFragmentDoc}`;

/**
 * __useSpecialTalentsDashboardQuery__
 *
 * To run a query within a React component, call `useSpecialTalentsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialTalentsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialTalentsDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpecialTalentsDashboardQuery(baseOptions?: Apollo.QueryHookOptions<SpecialTalentsDashboardQuery, SpecialTalentsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialTalentsDashboardQuery, SpecialTalentsDashboardQueryVariables>(SpecialTalentsDashboardDocument, options);
      }
export function useSpecialTalentsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialTalentsDashboardQuery, SpecialTalentsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialTalentsDashboardQuery, SpecialTalentsDashboardQueryVariables>(SpecialTalentsDashboardDocument, options);
        }
export type SpecialTalentsDashboardQueryHookResult = ReturnType<typeof useSpecialTalentsDashboardQuery>;
export type SpecialTalentsDashboardLazyQueryHookResult = ReturnType<typeof useSpecialTalentsDashboardLazyQuery>;
export type SpecialTalentsDashboardQueryResult = Apollo.QueryResult<SpecialTalentsDashboardQuery, SpecialTalentsDashboardQueryVariables>;
export const SpecialTalentsDocument = gql`
    query specialTalents($campId: ID!) {
  specialTalents(campId: $campId) {
    id
    firstname
    lastname
    birthday
    gender
    image
    booking_custom_checkbox_1
    booking_custom_checkbox_2
    voteEnabled
    talentClass
    trainer {
      id
      firstname
      lastname
      email
      head_coach
    }
  }
}
    `;

/**
 * __useSpecialTalentsQuery__
 *
 * To run a query within a React component, call `useSpecialTalentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialTalentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialTalentsQuery({
 *   variables: {
 *      campId: // value for 'campId'
 *   },
 * });
 */
export function useSpecialTalentsQuery(baseOptions: Apollo.QueryHookOptions<SpecialTalentsQuery, SpecialTalentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialTalentsQuery, SpecialTalentsQueryVariables>(SpecialTalentsDocument, options);
      }
export function useSpecialTalentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialTalentsQuery, SpecialTalentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialTalentsQuery, SpecialTalentsQueryVariables>(SpecialTalentsDocument, options);
        }
export type SpecialTalentsQueryHookResult = ReturnType<typeof useSpecialTalentsQuery>;
export type SpecialTalentsLazyQueryHookResult = ReturnType<typeof useSpecialTalentsLazyQuery>;
export type SpecialTalentsQueryResult = Apollo.QueryResult<SpecialTalentsQuery, SpecialTalentsQueryVariables>;
export const CertificateDocument = gql`
    query certificate {
  certificate {
    id
    talentId
    participantId
    caption
    camp {
      ...camp
    }
    vote
    image
    imageWithBackground
    birthday
    firstName
    lastName
    talentClass
  }
}
    ${CampFragmentDoc}`;

/**
 * __useCertificateQuery__
 *
 * To run a query within a React component, call `useCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCertificateQuery(baseOptions?: Apollo.QueryHookOptions<CertificateQuery, CertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CertificateQuery, CertificateQueryVariables>(CertificateDocument, options);
      }
export function useCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CertificateQuery, CertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CertificateQuery, CertificateQueryVariables>(CertificateDocument, options);
        }
export type CertificateQueryHookResult = ReturnType<typeof useCertificateQuery>;
export type CertificateLazyQueryHookResult = ReturnType<typeof useCertificateLazyQuery>;
export type CertificateQueryResult = Apollo.QueryResult<CertificateQuery, CertificateQueryVariables>;
export const CheckAccountAtJmtDocument = gql`
    query checkAccountAtJMT {
  checkAccountAtJMT {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useCheckAccountAtJmtQuery__
 *
 * To run a query within a React component, call `useCheckAccountAtJmtQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAccountAtJmtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAccountAtJmtQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckAccountAtJmtQuery(baseOptions?: Apollo.QueryHookOptions<CheckAccountAtJmtQuery, CheckAccountAtJmtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAccountAtJmtQuery, CheckAccountAtJmtQueryVariables>(CheckAccountAtJmtDocument, options);
      }
export function useCheckAccountAtJmtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAccountAtJmtQuery, CheckAccountAtJmtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAccountAtJmtQuery, CheckAccountAtJmtQueryVariables>(CheckAccountAtJmtDocument, options);
        }
export type CheckAccountAtJmtQueryHookResult = ReturnType<typeof useCheckAccountAtJmtQuery>;
export type CheckAccountAtJmtLazyQueryHookResult = ReturnType<typeof useCheckAccountAtJmtLazyQuery>;
export type CheckAccountAtJmtQueryResult = Apollo.QueryResult<CheckAccountAtJmtQuery, CheckAccountAtJmtQueryVariables>;
export const CreateAccountAndPushCertificateDocument = gql`
    mutation createAccountAndPushCertificate($input: CertificateCreateInput!) {
  createAccountAndPushCertificate(input: $input)
}
    `;
export type CreateAccountAndPushCertificateMutationFn = Apollo.MutationFunction<CreateAccountAndPushCertificateMutation, CreateAccountAndPushCertificateMutationVariables>;

/**
 * __useCreateAccountAndPushCertificateMutation__
 *
 * To run a mutation, you first call `useCreateAccountAndPushCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountAndPushCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountAndPushCertificateMutation, { data, loading, error }] = useCreateAccountAndPushCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountAndPushCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountAndPushCertificateMutation, CreateAccountAndPushCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountAndPushCertificateMutation, CreateAccountAndPushCertificateMutationVariables>(CreateAccountAndPushCertificateDocument, options);
      }
export type CreateAccountAndPushCertificateMutationHookResult = ReturnType<typeof useCreateAccountAndPushCertificateMutation>;
export type CreateAccountAndPushCertificateMutationResult = Apollo.MutationResult<CreateAccountAndPushCertificateMutation>;
export type CreateAccountAndPushCertificateMutationOptions = Apollo.BaseMutationOptions<CreateAccountAndPushCertificateMutation, CreateAccountAndPushCertificateMutationVariables>;
export const AddToAccountAndPushCertificateDocument = gql`
    mutation addToAccountAndPushCertificate($input: CertificateAddInput!) {
  addToAccountAndPushCertificate(input: $input)
}
    `;
export type AddToAccountAndPushCertificateMutationFn = Apollo.MutationFunction<AddToAccountAndPushCertificateMutation, AddToAccountAndPushCertificateMutationVariables>;

/**
 * __useAddToAccountAndPushCertificateMutation__
 *
 * To run a mutation, you first call `useAddToAccountAndPushCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToAccountAndPushCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToAccountAndPushCertificateMutation, { data, loading, error }] = useAddToAccountAndPushCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddToAccountAndPushCertificateMutation(baseOptions?: Apollo.MutationHookOptions<AddToAccountAndPushCertificateMutation, AddToAccountAndPushCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddToAccountAndPushCertificateMutation, AddToAccountAndPushCertificateMutationVariables>(AddToAccountAndPushCertificateDocument, options);
      }
export type AddToAccountAndPushCertificateMutationHookResult = ReturnType<typeof useAddToAccountAndPushCertificateMutation>;
export type AddToAccountAndPushCertificateMutationResult = Apollo.MutationResult<AddToAccountAndPushCertificateMutation>;
export type AddToAccountAndPushCertificateMutationOptions = Apollo.BaseMutationOptions<AddToAccountAndPushCertificateMutation, AddToAccountAndPushCertificateMutationVariables>;
export const SharedCertificateDocument = gql`
    query sharedCertificate($key: ID!) {
  sharedCertificate(key: $key) {
    id
    talentId
    participantId
    caption
    camp {
      ...camp
    }
    vote
    image
    imageWithBackground
    birthday
    firstName
    lastName
    talentClass
  }
}
    ${CampFragmentDoc}`;

/**
 * __useSharedCertificateQuery__
 *
 * To run a query within a React component, call `useSharedCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedCertificateQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useSharedCertificateQuery(baseOptions: Apollo.QueryHookOptions<SharedCertificateQuery, SharedCertificateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedCertificateQuery, SharedCertificateQueryVariables>(SharedCertificateDocument, options);
      }
export function useSharedCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedCertificateQuery, SharedCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedCertificateQuery, SharedCertificateQueryVariables>(SharedCertificateDocument, options);
        }
export type SharedCertificateQueryHookResult = ReturnType<typeof useSharedCertificateQuery>;
export type SharedCertificateLazyQueryHookResult = ReturnType<typeof useSharedCertificateLazyQuery>;
export type SharedCertificateQueryResult = Apollo.QueryResult<SharedCertificateQuery, SharedCertificateQueryVariables>;
export const ShareCertificateDocument = gql`
    mutation shareCertificate($participantId: ID!) {
  shareCertificate(participantId: $participantId)
}
    `;
export type ShareCertificateMutationFn = Apollo.MutationFunction<ShareCertificateMutation, ShareCertificateMutationVariables>;

/**
 * __useShareCertificateMutation__
 *
 * To run a mutation, you first call `useShareCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareCertificateMutation, { data, loading, error }] = useShareCertificateMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useShareCertificateMutation(baseOptions?: Apollo.MutationHookOptions<ShareCertificateMutation, ShareCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareCertificateMutation, ShareCertificateMutationVariables>(ShareCertificateDocument, options);
      }
export type ShareCertificateMutationHookResult = ReturnType<typeof useShareCertificateMutation>;
export type ShareCertificateMutationResult = Apollo.MutationResult<ShareCertificateMutation>;
export type ShareCertificateMutationOptions = Apollo.BaseMutationOptions<ShareCertificateMutation, ShareCertificateMutationVariables>;
export const RerunPersistCertificateDocument = gql`
    mutation rerunPersistCertificate($campId: Int!) {
  rerunPersistCertificate(campId: $campId)
}
    `;
export type RerunPersistCertificateMutationFn = Apollo.MutationFunction<RerunPersistCertificateMutation, RerunPersistCertificateMutationVariables>;

/**
 * __useRerunPersistCertificateMutation__
 *
 * To run a mutation, you first call `useRerunPersistCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunPersistCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunPersistCertificateMutation, { data, loading, error }] = useRerunPersistCertificateMutation({
 *   variables: {
 *      campId: // value for 'campId'
 *   },
 * });
 */
export function useRerunPersistCertificateMutation(baseOptions?: Apollo.MutationHookOptions<RerunPersistCertificateMutation, RerunPersistCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunPersistCertificateMutation, RerunPersistCertificateMutationVariables>(RerunPersistCertificateDocument, options);
      }
export type RerunPersistCertificateMutationHookResult = ReturnType<typeof useRerunPersistCertificateMutation>;
export type RerunPersistCertificateMutationResult = Apollo.MutationResult<RerunPersistCertificateMutation>;
export type RerunPersistCertificateMutationOptions = Apollo.BaseMutationOptions<RerunPersistCertificateMutation, RerunPersistCertificateMutationVariables>;
export const PrintCertificateDocument = gql`
    mutation printCertificate($participantId: ID!) {
  printCertificate(participantId: $participantId) {
    printKeyOne
    printKeyTwo
  }
}
    `;
export type PrintCertificateMutationFn = Apollo.MutationFunction<PrintCertificateMutation, PrintCertificateMutationVariables>;

/**
 * __usePrintCertificateMutation__
 *
 * To run a mutation, you first call `usePrintCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printCertificateMutation, { data, loading, error }] = usePrintCertificateMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function usePrintCertificateMutation(baseOptions?: Apollo.MutationHookOptions<PrintCertificateMutation, PrintCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrintCertificateMutation, PrintCertificateMutationVariables>(PrintCertificateDocument, options);
      }
export type PrintCertificateMutationHookResult = ReturnType<typeof usePrintCertificateMutation>;
export type PrintCertificateMutationResult = Apollo.MutationResult<PrintCertificateMutation>;
export type PrintCertificateMutationOptions = Apollo.BaseMutationOptions<PrintCertificateMutation, PrintCertificateMutationVariables>;
export const CheckJmtAccountDocument = gql`
    mutation checkJMTAccount($input: JmtUserInput!) {
  checkJMTAccount(input: $input) {
    id
    firstName
    lastName
    email
  }
}
    `;
export type CheckJmtAccountMutationFn = Apollo.MutationFunction<CheckJmtAccountMutation, CheckJmtAccountMutationVariables>;

/**
 * __useCheckJmtAccountMutation__
 *
 * To run a mutation, you first call `useCheckJmtAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckJmtAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkJmtAccountMutation, { data, loading, error }] = useCheckJmtAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckJmtAccountMutation(baseOptions?: Apollo.MutationHookOptions<CheckJmtAccountMutation, CheckJmtAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckJmtAccountMutation, CheckJmtAccountMutationVariables>(CheckJmtAccountDocument, options);
      }
export type CheckJmtAccountMutationHookResult = ReturnType<typeof useCheckJmtAccountMutation>;
export type CheckJmtAccountMutationResult = Apollo.MutationResult<CheckJmtAccountMutation>;
export type CheckJmtAccountMutationOptions = Apollo.BaseMutationOptions<CheckJmtAccountMutation, CheckJmtAccountMutationVariables>;
export const LoginToJmtAccountAndPushCertificateDocument = gql`
    mutation loginToJMTAccountAndPushCertificate($input: CertificateCreateWithJMTAccountInput!) {
  loginToJMTAccountAndPushCertificate(input: $input)
}
    `;
export type LoginToJmtAccountAndPushCertificateMutationFn = Apollo.MutationFunction<LoginToJmtAccountAndPushCertificateMutation, LoginToJmtAccountAndPushCertificateMutationVariables>;

/**
 * __useLoginToJmtAccountAndPushCertificateMutation__
 *
 * To run a mutation, you first call `useLoginToJmtAccountAndPushCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginToJmtAccountAndPushCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginToJmtAccountAndPushCertificateMutation, { data, loading, error }] = useLoginToJmtAccountAndPushCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginToJmtAccountAndPushCertificateMutation(baseOptions?: Apollo.MutationHookOptions<LoginToJmtAccountAndPushCertificateMutation, LoginToJmtAccountAndPushCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginToJmtAccountAndPushCertificateMutation, LoginToJmtAccountAndPushCertificateMutationVariables>(LoginToJmtAccountAndPushCertificateDocument, options);
      }
export type LoginToJmtAccountAndPushCertificateMutationHookResult = ReturnType<typeof useLoginToJmtAccountAndPushCertificateMutation>;
export type LoginToJmtAccountAndPushCertificateMutationResult = Apollo.MutationResult<LoginToJmtAccountAndPushCertificateMutation>;
export type LoginToJmtAccountAndPushCertificateMutationOptions = Apollo.BaseMutationOptions<LoginToJmtAccountAndPushCertificateMutation, LoginToJmtAccountAndPushCertificateMutationVariables>;
export const CreateJmtAccountAndPushCertificateDocument = gql`
    mutation createJMTAccountAndPushCertificate($input: CertificateCreateWithJMTAccountInput!) {
  createJMTAccountAndPushCertificate(input: $input)
}
    `;
export type CreateJmtAccountAndPushCertificateMutationFn = Apollo.MutationFunction<CreateJmtAccountAndPushCertificateMutation, CreateJmtAccountAndPushCertificateMutationVariables>;

/**
 * __useCreateJmtAccountAndPushCertificateMutation__
 *
 * To run a mutation, you first call `useCreateJmtAccountAndPushCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJmtAccountAndPushCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJmtAccountAndPushCertificateMutation, { data, loading, error }] = useCreateJmtAccountAndPushCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJmtAccountAndPushCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateJmtAccountAndPushCertificateMutation, CreateJmtAccountAndPushCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJmtAccountAndPushCertificateMutation, CreateJmtAccountAndPushCertificateMutationVariables>(CreateJmtAccountAndPushCertificateDocument, options);
      }
export type CreateJmtAccountAndPushCertificateMutationHookResult = ReturnType<typeof useCreateJmtAccountAndPushCertificateMutation>;
export type CreateJmtAccountAndPushCertificateMutationResult = Apollo.MutationResult<CreateJmtAccountAndPushCertificateMutation>;
export type CreateJmtAccountAndPushCertificateMutationOptions = Apollo.BaseMutationOptions<CreateJmtAccountAndPushCertificateMutation, CreateJmtAccountAndPushCertificateMutationVariables>;
export const GetAllTrainersDocument = gql`
    query getAllTrainers {
  getAllTrainers {
    sub
    given_name
    family_name
    name
    email
    roles
    isOriginalAdmin
  }
}
    `;

/**
 * __useGetAllTrainersQuery__
 *
 * To run a query within a React component, call `useGetAllTrainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTrainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTrainersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTrainersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTrainersQuery, GetAllTrainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTrainersQuery, GetAllTrainersQueryVariables>(GetAllTrainersDocument, options);
      }
export function useGetAllTrainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTrainersQuery, GetAllTrainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTrainersQuery, GetAllTrainersQueryVariables>(GetAllTrainersDocument, options);
        }
export type GetAllTrainersQueryHookResult = ReturnType<typeof useGetAllTrainersQuery>;
export type GetAllTrainersLazyQueryHookResult = ReturnType<typeof useGetAllTrainersLazyQuery>;
export type GetAllTrainersQueryResult = Apollo.QueryResult<GetAllTrainersQuery, GetAllTrainersQueryVariables>;
export const PromoteTrainerToAdminDocument = gql`
    mutation promoteTrainerToAdmin($email: String!) {
  promoteTrainerToAdmin(email: $email) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type PromoteTrainerToAdminMutationFn = Apollo.MutationFunction<PromoteTrainerToAdminMutation, PromoteTrainerToAdminMutationVariables>;

/**
 * __usePromoteTrainerToAdminMutation__
 *
 * To run a mutation, you first call `usePromoteTrainerToAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteTrainerToAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteTrainerToAdminMutation, { data, loading, error }] = usePromoteTrainerToAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePromoteTrainerToAdminMutation(baseOptions?: Apollo.MutationHookOptions<PromoteTrainerToAdminMutation, PromoteTrainerToAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteTrainerToAdminMutation, PromoteTrainerToAdminMutationVariables>(PromoteTrainerToAdminDocument, options);
      }
export type PromoteTrainerToAdminMutationHookResult = ReturnType<typeof usePromoteTrainerToAdminMutation>;
export type PromoteTrainerToAdminMutationResult = Apollo.MutationResult<PromoteTrainerToAdminMutation>;
export type PromoteTrainerToAdminMutationOptions = Apollo.BaseMutationOptions<PromoteTrainerToAdminMutation, PromoteTrainerToAdminMutationVariables>;
export const DemoteAdminToTrainerDocument = gql`
    mutation demoteAdminToTrainer($email: String!) {
  demoteAdminToTrainer(email: $email) {
    ...user
  }
}
    ${UserFragmentDoc}`;
export type DemoteAdminToTrainerMutationFn = Apollo.MutationFunction<DemoteAdminToTrainerMutation, DemoteAdminToTrainerMutationVariables>;

/**
 * __useDemoteAdminToTrainerMutation__
 *
 * To run a mutation, you first call `useDemoteAdminToTrainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDemoteAdminToTrainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [demoteAdminToTrainerMutation, { data, loading, error }] = useDemoteAdminToTrainerMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDemoteAdminToTrainerMutation(baseOptions?: Apollo.MutationHookOptions<DemoteAdminToTrainerMutation, DemoteAdminToTrainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DemoteAdminToTrainerMutation, DemoteAdminToTrainerMutationVariables>(DemoteAdminToTrainerDocument, options);
      }
export type DemoteAdminToTrainerMutationHookResult = ReturnType<typeof useDemoteAdminToTrainerMutation>;
export type DemoteAdminToTrainerMutationResult = Apollo.MutationResult<DemoteAdminToTrainerMutation>;
export type DemoteAdminToTrainerMutationOptions = Apollo.BaseMutationOptions<DemoteAdminToTrainerMutation, DemoteAdminToTrainerMutationVariables>;